module.exports = __webpack_public_path__ + "img/logo.1466b0b1.png";